import { computeDisplayedPotentialWin } from './betCartStakeLimits.js';

const finiteNumber = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};
const nonNegativeInteger = (value) => {
  const number = finiteNumber(value);
  return Number.isInteger(number) && number >= 0 ? number : null;
};

const firstDefined = (...values) => values.find(
  (value) => value !== undefined && value !== null && value !== ''
);

export const normalizeSportsnewComboBonusPreview = (quote) => {
  if (!quote || typeof quote !== 'object' || Array.isArray(quote)) return null;

  const baseOdds = finiteNumber(firstDefined(quote.base_odds, quote.baseOdds));
  const bonusMultiplier = finiteNumber(firstDefined(
    quote.bonus_multiplier,
    quote.bonusMultiplier
  ));
  const comboOddsAdjust = finiteNumber(firstDefined(
    quote.combo_odds_adjust,
    quote.comboOddsAdjust
  ));
  const totalOdds = finiteNumber(firstDefined(quote.total_odds, quote.totalOdds));
  const potentialWin = finiteNumber(firstDefined(quote.potential_win, quote.potentialWin));
  const requestedStake = finiteNumber(firstDefined(quote.requested_stake, quote.requestedStake));
  const quoteStake = finiteNumber(firstDefined(quote.stake, quote.quote_stake, quote.quoteStake));
  const policyMinimumStake = finiteNumber(firstDefined(
    quote.policy_minimum_stake,
    quote.policyMinimumStake
  ));
  const usesPolicyMinimumStake = firstDefined(
    quote.uses_policy_minimum_stake,
    quote.usesPolicyMinimumStake
  );
  const eligibleLegCount = nonNegativeInteger(firstDefined(
    quote.bonus_eligible_leg_count,
    quote.bonusEligibleLegCount,
    quote.combo_bonus_eligible_leg_count
  ));
  const tierLegCount = nonNegativeInteger(firstDefined(
    quote.bonus_tier_leg_count,
    quote.bonusTierLegCount,
    quote.combo_bonus_tier_leg_count
  ));
  const threshold = finiteNumber(firstDefined(
    quote.bonus_eligibility_threshold,
    quote.bonusEligibilityThreshold
  ));
  const modeValue = firstDefined(
    quote.bonus_eligibility_mode,
    quote.bonusEligibilityMode
  );

  if (
    baseOdds === null || baseOdds <= 0
    || bonusMultiplier === null || bonusMultiplier < 1
    || totalOdds === null || totalOdds <= 0
    || potentialWin === null || potentialWin < 0
  ) {
    return null;
  }

  return {
    baseOdds,
    bonusMultiplier,
    comboOddsAdjust: comboOddsAdjust ?? 0,
    totalOdds,
    potentialWin: Math.floor(potentialWin),
    requestedStake: requestedStake !== null && requestedStake >= 0 ? requestedStake : null,
    quoteStake: quoteStake !== null && quoteStake > 0 ? quoteStake : null,
    policyMinimumStake: policyMinimumStake !== null && policyMinimumStake > 0
      ? policyMinimumStake
      : null,
    usesPolicyMinimumStake: typeof usesPolicyMinimumStake === 'boolean'
      ? usesPolicyMinimumStake
      : null,
    eligibleLegCount,
    tierLegCount,
    threshold: threshold !== null && threshold >= 0 ? threshold : null,
    mode: modeValue == null ? null : String(modeValue),
  };
};

export const resolveSportsnewDisplayedPotentialWin = ({
  normalizedQuote,
  stake,
  displayedFinalOdds,
  bettingLimits,
}) => {
  const actualStake = finiteNumber(stake) ?? 0;
  const hasMatchingAuthoritativeStake = normalizedQuote?.usesPolicyMinimumStake === false
    && actualStake > 0
    && normalizedQuote.requestedStake === actualStake
    && normalizedQuote.quoteStake === actualStake;
  if (hasMatchingAuthoritativeStake) return normalizedQuote.potentialWin;
  return computeDisplayedPotentialWin({ stake, displayedFinalOdds, bettingLimits });
};

export const validateSportsnewPlacementPreflightQuote = ({ quote, stake }) => {
  const normalizedQuote = normalizeSportsnewComboBonusPreview(quote);
  const actualStake = finiteNumber(stake);
  const isActualStakeQuote = actualStake !== null
    && actualStake > 0
    && normalizedQuote?.usesPolicyMinimumStake === false
    && normalizedQuote.requestedStake === actualStake
    && normalizedQuote.quoteStake === actualStake;

  if (!isActualStakeQuote) {
    return {
      ok: false,
      message: '입력 금액의 최종 베팅 조건을 확인하지 못했습니다. 다시 시도해주세요',
    };
  }

  return { ok: true, normalizedQuote };
};
